import { useCurrentWell } from "@hooks/useCurrentWell";
import { OpenWellsExport } from "./OpenWellsExport";

/** Route wrapper: feeds the current well's UWI into the export screen. */
export function ExportRoute() {
  const { well } = useCurrentWell();
  return <OpenWellsExport wellUwi={well?.uwi ?? ""} />;
}
